<template>
  <v-dialog v-model="value" width="350" :persistent="persistent">
    <v-card>
      <div class="py-4">
        <v-alert
          class="text-xs-left no-outline"
          outlined
          colored-border
          :type="hideIcon ? undefined : status"
          ref="alertMessage"
        >
          <!-- :icon="status === 'success' ? 'check_circle' : 'warning'" -->
          <slot></slot>
        </v-alert>
      </div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text rounded v-if="cancelBtn" @click="$emit('cancel-btn-click')">
          {{ buttonName.cancel }}
        </v-btn>
        <v-btn color="primary" text rounded @click="$emit('ok-btn-click')">{{
          buttonName.ok
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DatePicker',
  data() {
    return {
      date: '',
      buttonName: { cancel: 'ยกเลิก', ok: 'ตกลง' }
    };
  },
  props: {
    status: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    cancelBtn: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    },
    hideIcon: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // closeAlertDialog(){
    //   this.setIsShow(false);
    //   this.$root.$emit('ok-btn-click')
    // },
    setIsShow(isShow) {
      this.$emit('input', isShow);
    }
  },
  // computed: {
  //   isShow() {
  //     return this.value
  //   }
  // },
  watch: {
    value(n, o) {
      this.$emit('input', n);
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.v-alert.no-outline {
  border: 0px !important;
  width: fit-content;
  margin: auto !important;
}

div.v-v-alert__content {
  color: black;
}
</style>
